import axios from "axios";

// Routed through the same-origin /api/proxy function (see client/api/proxy.ts)
// so the httpOnly session cookie stays first-party. In local dev without
// `vercel dev`, point REACT_APP_BASE_URL directly at the API and this base
// URL won't resolve; run `vercel dev` to exercise the real proxy locally.
const api = axios.create({
  baseURL: "/api/proxy",
  withCredentials: true,
});

export default api;
